module.exports = __webpack_public_path__ + "static/media/openEye.10787887.svg";